@if (loadingScreenService.loading()) {
  <div class="loading-screen">
    <app-rotary-spinner [size]="88" />
  </div>
}
